import * as React from 'react';

var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCalendarOutline24 = function SvgCalendarOutline24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.238 2.4V0h-.952v2.4H7.714V0h-.952v2.4H2V24h20V2.4h-4.762zm-10.476.96v2.4h.952v-2.4h8.572v2.4h.952v-2.4h3.81v4.8H2.952v-4.8h3.81zm-3.81 19.68V9.12h18.096v13.92H2.952z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.19 13.44h-3.333v-3.36h-.952v3.36H12.57v-3.36h-.952v3.36H8.286v-3.36h-.953v3.36H4v.96h3.333v7.68h.953V14.4h3.333v7.68h.952V14.4h3.334v7.68h.952V14.4h3.334v-.96z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.19 17.76H4v.96h16.19v-.96z",
    fill: "currentColor"
  })));
};

var CalendarOutline24Svg = SvgCalendarOutline24;

export { CalendarOutline24Svg as default };
//# sourceMappingURL=CalendarOutline24.svg.js.map
